module.exports = __webpack_public_path__ + "static/flags/CL-276974dab748be68cc04310e4df53a52.gif";